<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright">
        &copy; {{ year }}
      </div>
    </div>
  </footer>
</template>
<script>

export default {
  name:"Footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped></style>
